import { Close as ResetIcon, Search as SearchIcon } from "@mui/icons-material";
import { Box, IconButton, Stack, TextField } from "@mui/material";
import type { FC } from "react";
import { Select } from "../components/select/Select";
import { useProviders } from "./providers/useProviders";
import type { ProductFilters } from "./useAdminFilters";

interface Props {
  readonly filters: ProductFilters;
  readonly onChange: (filters: ProductFilters) => void;
}

const ProductSearch: FC<Props> = ({ filters, onChange }) => {
  const { providers } = useProviders();

  return (
    <Stack direction="row" sx={{ alignItems: "center" }} spacing={2}>
      <SearchIcon />
      <Box sx={{ flexBasis: 0, flexGrow: 1 }}>
        <TextField
          fullWidth
          value={filters.query}
          label="Szukaj"
          onChange={(e) => onChange({ ...filters, query: e.target.value })}
        />
      </Box>
      <Box sx={{ flexBasis: 0, flexGrow: 1 }}>
        <Select
          label="Dostawca"
          fullWidth
          value={filters.providerId ?? ""}
          values={providers.map((p) => ({ value: p.id, label: p.name }))}
          onSelect={(providerId) => onChange({ ...filters, providerId })}
        />
      </Box>
      <IconButton color="inherit" onClick={() => onChange({ query: "", providerId: undefined })}>
        <ResetIcon />
      </IconButton>
    </Stack>
  );
};

export default ProductSearch;
